core.factory('core.applicationService', ['$q', 'core.baseService', 'core.objectHelper', '$injector',
	function ($q, baseService, objectHelper, $injector) {

		function ApplicationService() {

            var config = {};
            if($injector.has('meedyConfig')) {
                config = $injector.get('meedyConfig');
            } else if($injector.has('edmConstant')) {
                config = $injector.get('config');
            } else {
                config = $injector.get('coreConfig');
            }

			this.getCustomConfig = function () {
				// this is optional
				return baseService.get('./custom-config.json', baseService.createSupressErrorsConfig()).then(
					function (successResponse) {
						var result = objectHelper.translateObject(successResponse, CustomConfigVO);
						return result;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.sendError = function (applicationError) {
				return baseService.post(config.API_URL + '/angularException/sendException', applicationError, baseService.createSupressErrorsConfig()).then(
					function (successResponse) {
						return true;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
		}

		return new ApplicationService();
	}
]);
